import React from "react";
import "./css/styles.css";
import { useCallback } from "react";

function Landing() {
  const onReviewQuoteSeparatorClick = useCallback(() => {
    window.open("https://sites.google.com/view/ahmadtarrabeih2021/home");
  }, []); 

  const onContactImageClick = useCallback(() => {
    window.open("https://www.facebook.com/Tarrabeih?mibextid=ZbWKwL");
  }, []);

  const onContactImage1Click = useCallback(() => {
    window.open("https://wa.me/96176067086");
  }, []);

  const onContactImage2Click = useCallback(() => {
    window.open("https://www.linkedin.com/in/ahmad-tarrabeih-b94262193/");
  }, []);

  const onContactImage3Click = useCallback(() => {
    window.open(
      "https://www.instagram.com/tarrabeih?igsh=MTY3NmZ5eGhybWF5bA=="
    );
  }, []);


  const onFrameContainer1Click = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='services']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  const onFrameContainer2Click = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='portfolio']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  const onFrameContainer3Click = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='testimonials']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  const onFrameContainer4Click = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='contact']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  const onFrameContainer5Click = useCallback(() => {
    const anchor = document.querySelector("[data-scroll-to='home']");
    if (anchor) {
      anchor.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, []);

  return (
    <>
       <header className="about-me-wrapper">
      <div className="about-me">
        <h2 className="ahmad-tarrabeih">Ahmad Tarrabeih</h2>
        <div className="frame-parent">
          <div className="home-wrapper" style={{cursor: 'pointer'}} onClick={onFrameContainer5Click}>
            <b className="home1">Home</b>
          </div>
          <div className="services-wrapper" onClick={onFrameContainer1Click}>
            <b className="services">Services</b>
          </div>
          <div className="portfolio-wrapper" onClick={onFrameContainer2Click}>
            <b className="portfolio">Portfolio</b>
          </div>
          <div
            className="testimonials-wrapper"
            onClick={onFrameContainer3Click}
          >
            <b className="testimonials">Testimonials</b>
          </div>
          <div className="contact-wrapper" onClick={onFrameContainer4Click}>
            <b className="contact">Contact</b>
          </div>
        </div>
      </div>
    </header>

      <div className="header" data-scroll-to="home">
        <div className="header-inner">
          <div className="im-ahmad-tarrabeih-parent">
            <h1 className="im-ahmad-tarrabeih">I’m Ahmad Tarrabeih</h1>
            <div className="full-stack-developer-parent">
              <div className="full-stack-developer">Full stack Developer</div>
              <div className="div">/</div>
              <div className="mobile-developer-wrapper">
                <div className="mobile-developer">Mobile Developer</div>
              </div>
              <div className="div1">/</div>
              <div className="data-scientist-wrapper">
                <div className="data-scientist">{`Data Scientist `}</div>
              </div>
            </div>
            <div className="as-a-versatile">
              As a versatile professional, I excel at merging technology with
              data analysis. Specializing as a Fullstack Developer, I create
              comprehensive web solutions. My expertise as a Data Scientist lies
              in extracting insights from complex datasets, driving innovation.
            </div>
          </div>
        </div>
        <div className="ellipse-parent">
          <div className="frame-child" />
          <div className="frame-item" />
          <img
            className="frame-inner"
            loading="lazy"
            alt=""
            src="assets/ellipse-2.png"
          />
        </div>
      </div>

      <section className="services1" data-scroll-to="services">
        <div className="my-services-wrapper">
          <h1 className="my-services">
            <span>{`My `}</span>
            <span className="services2">Services</span>
          </h1>
        </div>
        <div className="frame-group">
          <div className="vector-parent">
            <img
              className="vector-icon"
              loading="lazy"
              alt=""
              src="assets/vector.svg"
            />
            <div className="fullstack-web-development-parent">
              <div className="fullstack-web-development">
                Fullstack Web Development
              </div>
              <div className="leverage-my-expertise">
                Leverage my expertise in front-end and back-end development to
                create customized web solutions that meet your specific
                requirements.
              </div>
            </div>
          </div>
          <div className="icon-park-outlineanalysis-parent">
            <img
              className="icon-park-outlineanalysis"
              loading="lazy"
              alt=""
              src="assets/iconparkoutlineanalysis.svg"
            />
            <div className="frame-wrapper">
              <div className="data-analysis-and-insights-parent">
                <div className="data-analysis-and">
                  Data Analysis and Insights
                </div>
                <div className="harness-the-power">
                  Harness the power of data with advanced statistical methods
                  and machine learning algorithms to uncover valuable insights
                  that drive informed decision-making.
                </div>
              </div>
            </div>
          </div>
          <div className="mdiweb-parent">
            <img
              className="mdiweb-icon"
              loading="lazy"
              alt=""
              src="assets/mdiweb.svg"
            />
            <div className="frame-container">
              <div className="custom-web-solutions-parent">
                <div className="custom-web-solutions">Custom Web Solutions</div>
                <div className="craft-tailored-web">
                  Craft tailored web applications designed to optimize user
                  experience and functionality, ensuring seamless interaction
                  and satisfaction.
                </div>
              </div>
            </div>
          </div>
          <div className="material-symbolsproblem-outli-parent">
            <img
              className="material-symbolsproblem-outli-icon"
              loading="lazy"
              alt=""
              src="assets/materialsymbolsproblemoutlinerounded.svg"
            />
            <div className="frame-div">
              <div className="innovative-problem-solving-parent">
                <div className="innovative-problem-solving">
                  Innovative Problem-Solving
                </div>
                <div className="tackle-complex-challenges">
                  Tackle complex challenges with creative problem-solving
                  techniques, using cutting-edge analytical methods to drive
                  innovation in technology and data analysis.
                </div>
              </div>
            </div>
          </div>
          <div className="carbondevelopment-parent">
            <img
              className="carbondevelopment-icon"
              loading="lazy"
              alt=""
              src="assets/carbondevelopment.svg"
            />
            <div className="frame-wrapper1">
              <div className="scalable-application-developme-parent">
                <div className="scalable-application-developme">
                  Scalable Application Development
                </div>
                <div className="build-robust-and">
                  Build robust and scalable web applications that can adapt and
                  grow with your business, incorporating industry best practices
                  for performance and reliability.
                </div>
              </div>
            </div>
          </div>
          <div className="frame-parent1">
            <div className="material-symbolsperson-wrapper">
              <img
                className="material-symbolsperson-icon"
                loading="lazy"
                alt=""
                src="assets/materialsymbolsperson.svg"
              />
            </div>
            <div className="client-centric-approach-parent">
              <div className="client-centric-approach">
                Client-Centric Approach
              </div>
              <div className="prioritize-client-satisfaction">
                Prioritize client satisfaction by continuously adapting to their
                needs and preferences, ensuring that solutions are always
                aligned with their goals and expectations.
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio1" data-scroll-to="portfolio">
        <div className="my-portfolio-wrapper">
          <h1 className="my-portfolio">
            <span className="my-portfolio-txt-container">
              <span>{`My `}</span>
              <span className="portfolio2">Portfolio</span>
              <span>{` `}</span>
            </span>
          </h1>
        </div>
        <div className="quote-container">
          <div
            className="review-quote-separator"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-towfiqu-barbhu"
              loading="lazy"
              alt=""
              src="assets/pexels-photo-by-towfiqu-barbhuiya@2x.png"
            />
            <b className="attendance-management-system">
              Attendance Management System
            </b>
          </div>
          <div
            className="review-quote-separator1"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-karolina-grabo"
              loading="lazy"
              alt=""
              src="assets/pexels-photo-by-karolina-grabowska@2x.png"
            />
            <b className="streamlining-patient-managemen">
              Streamlining Patient Management V2
            </b>
          </div>
          <div
            className="review-quote-separator2"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-karolina-grabo1"
              alt=""
              src="assets/pexels-photo-by-karolina-grabowska@2x.png"
            />
            <b className="streamlining-patient-managemen1">
              Streamlining Patient Management V1
            </b>
          </div>
          <div
            className="review-quote-separator3"
            onClick={onReviewQuoteSeparatorClick}
          >
            <div className="pexels-photo-by-breakingpic-parent">
              <img
                className="pexels-photo-by-breakingpic"
                alt=""
                src="./assets/pexels-photo-by-breakingpic@2x.png"
              />
              <b className="multi-task-management">{`Multi Task Management `}</b>
            </div>
          </div>
          <div
            className="review-quote-separator4"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-karolina-grabo2"
              alt=""
              src="assets/pexels-photo-by-karolina-grabowska-2@2x.png"
            />
            <b className="smart-clinic-manger">Smart Clinic Manger</b>
          </div>
          <div
            className="review-quote-separator5"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-obsahovka-obsa"
              loading="lazy"
              alt=""
              src="assets/pexels-photo-by-obsahovka-obsahovka@2x.png"
            />
            <b className="quick-fix">{`Quick Fix `}</b>
          </div>
          <div
            className="review-quote-separator6"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-cottonbro-stud"
              loading="lazy"
              alt=""
              src="assets/pexels-photo-by-cottonbro-studio@2x.png"
            />
            <b className="human-resource-ms">Human Resource MS</b>
          </div>
          <div
            className="review-quote-separator7"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-pixabay"
              loading="lazy"
              alt=""
              src="assets/pexels-photo-by-pixabay@2x.png"
            />
            <b className="clinic-web-application">Clinic web Application</b>
          </div>
          <div
            className="review-quote-separator8"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-cottonbro-stud1"
              alt=""
              src="assets/pexels-photo-by-cottonbro-studio-1@2x.png"
            />
            <b className="say-it-true">Say it True</b>
          </div>
          <div
            className="review-quote-separator9"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-alex-green"
              loading="lazy"
              alt=""
              src="assets/pexels-photo-by-alex-green@2x.png"
            />
            <b className="octopus-consultancy-pro">Octopus Consultancy Pro</b>
          </div>
          <div
            className="review-quote-separator10"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-lukas"
              loading="lazy"
              alt=""
              src="assets/pexels-photo-by-lukas@2x.png"
            />
            <b className="sari-data-analysis">Sari Data Analysis</b>
          </div>
          <div
            className="review-quote-separator11"
            onClick={onReviewQuoteSeparatorClick}
          >
            <img
              className="pexels-photo-by-pixabay1"
              alt=""
              src="assets/pexels-photo-by-pixabay-1@2x.png"
            />
            <b className="measles-data-analysis">Measles Data Analysis</b>
          </div>
        </div>
      </section>

      <section className="testimonials1" data-scroll-to="testimonials">
        <h1 className="listen-to-my-container">
          <span>{`Listen to my `}</span>
          <span className="custormers">Customers</span>
        </h1>
        <div className="contact-input-container">
          <div className="customer-feedback-card">
            <div className="customer-feedback-card1">
              <div className="customer-feedback-card2">
                <img
                  className="healthiconsui-user-profile"
                  loading="lazy"
                  alt=""
                  src="assets/healthiconsuiuserprofile.svg"
                />
              </div>
              <div className="working-with-ahmed">
                Working with Ahmed Tarabein was an absolute pleasure. His
                attention to detail and ability to understand our project
                requirements surpassed our expectations. The website he built
                for us not only looks fantastic but also functions seamlessly.
                Highly recommend!
              </div>
            </div>
            <div className="send-button-wrapper">
              <div className="send-button">
                <b className="dr-b-tarabein">Dr. B Tarabein</b>
                <div className="customer-name-and-quote" />
              </div>
            </div>
          </div>
          <div className="customer-feedback-card3">
            <div className="healthiconsui-user-profile-wrapper">
              <img
                className="healthiconsui-user-profile1"
                alt=""
                src="assets/healthiconsuiuserprofile-1.svg"
              />
            </div>
            <div className="i-cannot-thank-ahmad-tarabain-parent">
              <div className="i-cannot-thank">
                I cannot thank Ahmad tarabain enough for his expertise and
                professionalism. He was able to turn our vision into reality
                with his exceptional coding skills and innovative solutions. Our
                website has received rave reviews from our clients, and we owe
                it all to Ahmad Tarrabeih.
              </div>
              <div className="customer-name-and-quote1">
                <b className="mr-moe-tarabay">{`Mr. Moe Tarabay `}</b>
                <div className="customer-name-and-quote2" />
              </div>
            </div>
          </div>
          <div className="customer-feedback-card4">
            <div className="healthiconsui-user-profile-container">
              <img
                className="healthiconsui-user-profile2"
                alt=""
                src="assets/healthiconsuiuserprofile-1.svg"
              />
            </div>
            <div className="hiring-ahmad-tarabay-was-one-o-parent">
              <div className="hiring-ahmad-tarabay">
                Hiring Ahmad tarabay was one of the best decisions we made for
                our business. He was not only technically proficient but also
                incredibly responsive and communicative throughout the entire
                development process. His dedication to delivering high-quality
                work is commendable.
              </div>
              <div className="telnet-it-team-parent">
                <b className="telnet-it-team">Telnet IT Team</b>
                <div className="line-div" />
              </div>
            </div>
          </div>
          <div className="customer-feedback-card5">
            <div className="healthiconsui-user-profile-frame">
              <img
                className="healthiconsui-user-profile3"
                alt=""
                src="assets/healthiconsuiuserprofile.svg"
              />
            </div>
            <div className="frame-parent2">
              <div className="ive-had-the-pleasure-of-colla-wrapper">
                <div className="ive-had-the">
                  I've had the pleasure of collaborating with Ahmad tarabein on
                  multiple projects, and each time he has exceeded my
                  expectations. His expertise in web development combined with
                  his professionalism and reliability make him a valuable asset
                  to any team.
                </div>
              </div>
              <div className="dr-a-tarabein-parent">
                <b className="dr-a-tarabein">Dr. A Tarabein</b>
                <div className="frame-child1" />
              </div>
            </div>
          </div>
          <div className="customer-feedback-card6">
            <div className="healthiconsui-user-profile-wrapper1">
              <img
                className="healthiconsui-user-profile4"
                alt=""
                src="assets/healthiconsuiuserprofile.svg"
              />
            </div>
            <div className="frame-parent3">
              <div className="from-start-to-finish-ahmad-de-wrapper">
                <div className="from-start-to">
                  From start to finish, Ahmad demonstrated a deep understanding
                  of our project goals and delivered a website that perfectly
                  aligned with our vision. His problem-solving skills and
                  attention to detail ensured that our website not only looked
                  great but also performed flawlessly.
                </div>
              </div>
              <div className="line-parent">
                <div className="frame-child2" />
                <div className="octopus-consultancy-pro-team-wrapper">
                  <b className="octopus-consultancy-pro-container">
                    <span>
                      <p className="octopus-consultancy-pro1">
                        Octopus Consultancy Pro Team
                      </p>
                    </span>
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className="customer-feedback-card7">
            <div className="healthiconsui-user-profile-wrapper2">
              <img
                className="healthiconsui-user-profile5"
                alt=""
                src="assets/healthiconsuiuserprofile-1.svg"
              />
            </div>
            <div className="frame-parent4">
              <div className="i-couldnt-be-happier-with-the-wrapper">
                <div className="i-couldnt-be">
                  I couldn't be happier with the results ahmad tarabey
                  delivered. He was able to transform our outdated website into
                  a modern and user-friendly platform that has significantly
                  improved our online presence. His dedication to delivering
                  excellence is evident in every aspect of his work.
                </div>
              </div>
              <div className="telnet-hr-parent">
                <b className="telnet-hr">Telnet HR</b>
                <div className="frame-child3" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="contact1" data-scroll-to="contact">
        <h1 className="get-in-touch-container">
          <span>{`Get in `}</span>
          <span className="touch">Touch</span>
        </h1>
        <div className="pexels-photo-by-francesco-unga-parent">
          <img
            className="pexels-photo-by-francesco-unga"
            alt=""
            src="assets/pexels-photo-by-francesco-ungaro@2x.png"
          />
          <img
            className="contact-image-icon"
            loading="lazy"
            alt=""
            src="assets/facebook-svgrepo-com.svg"
            onClick={onContactImageClick}
          />
          <img
            className="contact-image-icon1"
            loading="lazy"
            alt=""
            src="assets/whatsapp-svgrepo-com.svg"
            onClick={onContactImage1Click}
          />
          <img
            className="contact-image-icon2"
            loading="lazy"
            alt=""
            src="assets/linkedin-svgrepo-com.svg" 
            onClick={onContactImage2Click}
          />
          <img
            className="contact-image-icon3"
            loading="lazy"
            alt=""
            src="assets/instagram-svgrepo-com.svg"
            onClick={onContactImage3Click}
          />
        </div>
      </footer>

    </>
  );
}

export default Landing;
